import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { timestampToFormattedDate } from 'utils/Date/DateUtils';
import { formatToDecimal } from 'utils/Number/NumberUtils';

export default class PaymentPlanTable extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <BootstrapTable data={this.props.quotas} height='200' scrollTop={'Top'}>
                <TableHeaderColumn dataField='number' isKey>Nro. Cuota</TableHeaderColumn>
                <TableHeaderColumn dataField='dueDate' dataFormat={timestampToFormattedDate}>Fecha a Pagar</TableHeaderColumn>
                <TableHeaderColumn dataField='typeLabel'>Tipo de Cuota</TableHeaderColumn>
                <TableHeaderColumn dataField='amountFormatted'>Monto a Pagar</TableHeaderColumn>
            </BootstrapTable>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/PaymentPlanTable/PaymentPlanTable.jsx